module.exports = __webpack_public_path__ + "static/media/linkedin-icon.676ccd91.svg";